import { useMemo } from 'react';
import { useOvermindState } from '#store/overmind';

const useContinueWatching = (iri) => {
  const { items } = useOvermindState().continueWatching;

  const continueWatchingItem = useMemo(() => {
    return items.find((cwItem) => cwItem.mediaIri === iri) || null;
  }, [items, iri]);

  return { continueWatchingItem };
};

export default useContinueWatching;
